
    import { Buffer } from 'buffer';
    if (typeof window.Buffer === 'undefined') {
      // This is for the `json-schema-ref-parser` package, which has a hard dependency on a globally available `Buffer`
      // Note that 'jszip' also uses this, but won't break without it, but this constrains how we can polyfill it.
      window.Buffer = Buffer;
    }
  